import { useCallback, useRef } from 'react';
import { createNextSpawn } from '../systems/spawner.js';

export function useSpawner({ difficulty, boardRef, enrichmentProgressRef, random = Math.random }) {
    const nextSpawnAtRef = useRef(0);

    const resetSpawner = useCallback(() => {
        nextSpawnAtRef.current = 0;
    }, []);

    const maybeSpawn = useCallback(
        (state) => {
            const nowMs = Date.now();

            if (nowMs < nextSpawnAtRef.current) {
                return state;
            }

            const rect = boardRef.current?.getBoundingClientRect?.();
            const boardSize = {
                width: rect?.width || 1,
                height: rect?.height || 1,
            };

            const { item, nextSpawnInMs } = createNextSpawn({
                difficulty,
                state,
                boardSize,
                nowMs,
                random,
                enrichmentProgress: enrichmentProgressRef?.current ?? null,
            });

            nextSpawnAtRef.current = nowMs + nextSpawnInMs;

            if (!item) return state;

            return {
                ...state,
                items: [...state.items, item],
            };
        },
        [boardRef, difficulty, enrichmentProgressRef, random],
    );

    return {
        maybeSpawn,
        resetSpawner,
    };
}
